import { Theme } from '@mui/material/styles'
import { makeStyles } from '@mui/styles'

export const useStyles = makeStyles((theme: Theme) => ({
  chipBoxZones: {
    display: 'flex',
    justifyContent: 'center',
    flexWrap: 'wrap',
    '& > *': {
      margin: theme.spacing(0.5)
    }
  },
  root: {
    minHeight: '200px',
    maxWidth: 345
  },
  small: {
    display: 'flex',
    flexDirection: 'column',
    padding: '10px'
  }
}))
